export default "__VITE_ASSET__ba4e9411__"